var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "0px" } },
    [
      _vm.visible
        ? _c(
            "div",
            {
              staticClass: "smart-hover-popover",
              style: _vm.popoverStyle,
              on: {
                mouseenter: _vm.handlePopoverMouseEnter,
                mouseleave: _vm.handlePopoverMouseLeave,
              },
            },
            [
              _c(
                "div",
                { staticClass: "smart-hover-actions" },
                [
                  _vm.detectedType === "automation-webhook"
                    ? [
                        _c("div", { staticClass: "action-header" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("link"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "action-title" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.detectedData &&
                                    _vm.detectedData.automation
                                    ? _vm.detectedData.automation.name
                                    : _vm.$t("message.automationLink")
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "action-buttons" }, [
                          _c(
                            "button",
                            {
                              staticClass: "action-btn primary",
                              on: { click: _vm.goToAutomation },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("open_in_new"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.goToAutomation"))
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "action-btn",
                              on: { click: _vm.copyToClipboard },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("content_copy"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("message.copyUrl"))),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.detectedType === "phone"
                    ? [
                        _c("div", { staticClass: "action-header" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("phone"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "action-title" }, [
                            _vm._v(_vm._s(_vm.detectedContent)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "action-buttons" }, [
                          _vm.hasAiVoiceAgentPermission
                            ? _c(
                                "button",
                                {
                                  staticClass: "action-btn ai-call",
                                  on: { click: _vm.startAiCall },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("smart_toy"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("message.callWithAi"))
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "action-btn webphone-call",
                              on: { click: _vm.startWebphoneCall },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("phone_in_talk"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.callWithWebphone"))
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.hasWhatsappChannel
                            ? _c(
                                "button",
                                {
                                  staticClass: "action-btn whatsapp",
                                  on: { click: _vm.startWhatsappChat },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("chat"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("message.writeOnWhatsapp"))
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "action-btn",
                              on: { click: _vm.copyToClipboard },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("content_copy"),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v("Kopyala")]),
                            ]
                          ),
                        ]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.detectedType === "email"
                    ? [
                        _c("div", { staticClass: "action-header" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("email"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "action-title" }, [
                            _vm._v(_vm._s(_vm.detectedContent)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "action-buttons" }, [
                          _c(
                            "button",
                            {
                              staticClass: "action-btn primary",
                              on: { click: _vm.sendSupsisMail },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("send"),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v("Mail Gönder (Supsis ile)")]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "action-btn",
                              on: { click: _vm.openMailTo },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("open_in_new"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v("Mail Gönder (Mail Uygulaması)"),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "action-btn",
                              on: { click: _vm.copyToClipboard },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("content_copy"),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v("Kopyala")]),
                            ]
                          ),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showWhatsappModal
        ? _c(
            "Modal2",
            {
              staticClass: "modal-wp-chat-starter",
              attrs: { "show-footer": false, title: "WhatsApp Sohbet Başlat" },
              on: { cancel: _vm.closeWhatsappModal },
            },
            [
              _c("WhatsappChatStarter", {
                attrs: {
                  "default-phone-number": _vm.whatsappPhoneNumber,
                  "channel-override": "",
                  "phone-number-override": "",
                },
                on: { close: _vm.closeWhatsappModal },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("AiVoiceAgentCallStarter", {
        ref: "aiCallStarter",
        attrs: {
          contact: _vm.aiCallContact,
          "default-to-number": _vm.aiCallPhoneNumber,
          "hide-button": true,
        },
        on: { close: _vm.closeAiCallModal },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }